/* src/app/main/pages/about/about-content/about-content.component.css */
.main-div .number {
  color: rgb(227 100 10 / 0.77);
  padding-right: 6px;
}
.main-div .bg-img-top::after {
  content: "";
  position: absolute;
  background-image: url(/assets/images/our-services/bg-triangle.png);
  right: 0;
  background-repeat: no-repeat;
  background-size: 200px auto;
  width: 200px;
  height: 300px;
  top: 0px;
}
.main-div .bg-img-bottom::after {
  content: "";
  position: absolute;
  background-image: url(/assets/images/our-services/services-bg-triangle.png);
  right: 0;
  background-repeat: no-repeat;
  background-size: 200px auto;
  width: 200px;
  height: 225px;
  bottom: 0px;
}
.service-sub-full-bg {
  background-image:
    linear-gradient(
      to left,
      rgb(255 255 255 / 0),
      rgb(33 54 84 / 1)),
    url(/assets/images/our-services/air-services/sea_air.jpg);
  background-position: center;
  background-size: cover;
  padding-top: 80px;
  padding-bottom: 80px;
  position: relative;
}
.service-sub-full-bg::before {
  content: "";
  position: absolute;
  background-color: #E8882D;
  width: 370px;
  height: 5px;
  top: 0;
}
.sat-history {
  background-color: #FAFAFA;
  padding-top: 30px;
  padding-bottom: 30px;
}
.before-arrow-img::before {
  content: "";
  position: absolute;
  background-image: url(/assets/images/about/about-image-before.png);
  left: 0;
  background-repeat: no-repeat;
  background-size: 200px auto;
  width: 200px;
  height: 260px;
  top: 0px;
}
.before-arrow-img-2::before {
  content: "";
  position: absolute;
  background-image: url(/assets/images/about/about-image-before-2.png);
  left: 0;
  background-repeat: no-repeat;
  background-size: 200px auto;
  width: 200px;
  height: 240px;
  top: 0px;
}
@media (min-width: 1680px) {
  .main-div h2,
  .service-sub-full-bg h2 {
    margin-bottom: 25px !important;
  }
  .main-div p,
  .service-sub-full-bg p {
    font-size: 20px;
  }
}
@media (min-width: 1600px) and (max-width: 1679px) {
  .main-div p,
  .service-sub-full-bg p {
    font-size: 20px;
  }
}
@media (max-width: 1024px) {
  .main-div p {
    margin-bottom: 50px;
  }
}
@media (max-width: 767px) {
  .service-sub-full-bg::before {
    width: 170px;
  }
  .air-service-banner-row h1 {
    font-size: 40px;
  }
  .service-sub-full-bg {
    padding-top: 40px;
    padding-bottom: 40px;
  }
}
@media (min-device-width: 1440px) and (max-device-width: 1599px) {
  .main-div p,
  .service-sub-full-bg p {
    font-size: 17px;
  }
}
/*# sourceMappingURL=about-content.component.css.map */
